// src/ar/recorder/arFlags.ts
var BACKEND_KEY = "mt-ar-backend";
var RECORD_KEY = "mt-ar-record";
var LATENCY_KEY = "mt-ar-latency";
var SYNC_KEY = "mt-ar-sync";
var GYRO_KEY = "mt-ar-gyro";
var COAST_KEY = "mt-ar-coast";
var BACKENDS = [
  "trailslam",
  "webxr",
  "fallback"
];
function urlParam(name) {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch {
    return null;
  }
}
function stored(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}
function store(key, value) {
  try {
    if (value === null) window.sessionStorage.removeItem(key);
    else window.sessionStorage.setItem(key, value);
  } catch {
  }
}
var parseBackend = (value) => value !== null && BACKENDS.includes(value) ? value : null;
var parseLatency = (value) => {
  if (value === null || value === "") return null;
  const ms = Number(value);
  return Number.isFinite(ms) && ms >= 0 && ms <= 400 ? ms : null;
};
function captureArTestFlags() {
  if (typeof window === "undefined") return;
  const backend = urlParam("arBackend");
  if (backend !== null) store(BACKEND_KEY, parseBackend(backend));
  const record = urlParam("arRecord");
  if (record !== null) store(RECORD_KEY, record === "1" ? "1" : null);
  const latency = urlParam("arLatency");
  if (latency !== null) {
    const ms = parseLatency(latency);
    store(LATENCY_KEY, ms === null ? null : String(ms));
  }
  for (const [name, key] of ON_OFF_FLAGS) {
    const value = urlParam(name);
    if (value !== null) store(key, value === "0" ? "0" : null);
  }
}
var ON_OFF_FLAGS = [
  ["arSync", SYNC_KEY],
  ["arGyro", GYRO_KEY],
  ["arCoast", COAST_KEY]
];
var onOffFlag = (name, key) => {
  if (typeof window === "undefined") return true;
  const fromUrl = urlParam(name);
  if (fromUrl !== null) return fromUrl !== "0";
  return stored(key) !== "0";
};
var isArSyncActive = () => onOffFlag("arSync", SYNC_KEY);
var isArGyroActive = () => onOffFlag("arGyro", GYRO_KEY);
var isArCoastActive = () => onOffFlag("arCoast", COAST_KEY);
function arBackendOverride() {
  if (typeof window === "undefined") return null;
  const fromUrl = urlParam("arBackend");
  if (fromUrl !== null) return parseBackend(fromUrl);
  return parseBackend(stored(BACKEND_KEY));
}
function isArRecordActive() {
  if (typeof window === "undefined") return false;
  const fromUrl = urlParam("arRecord");
  if (fromUrl !== null) return fromUrl === "1";
  return stored(RECORD_KEY) === "1";
}
function arLatencyOverrideMs() {
  if (typeof window === "undefined") return null;
  const fromUrl = urlParam("arLatency");
  if (fromUrl !== null) return parseLatency(fromUrl);
  return parseLatency(stored(LATENCY_KEY));
}
captureArTestFlags();

// src/ar/arDebugFlag.ts
var KEY = "mt-ar-debug";
function urlHasFlag() {
  try {
    return new URLSearchParams(window.location.search).get("arDebug") === "1";
  } catch {
    return false;
  }
}
function captureArDebugFlag() {
  if (typeof window === "undefined") return;
  try {
    if (urlHasFlag()) window.sessionStorage.setItem(KEY, "1");
  } catch {
  }
}
function isArDebugActive() {
  if (typeof window === "undefined") return false;
  if (urlHasFlag()) return true;
  try {
    return window.sessionStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}
captureArDebugFlag();

// src/ar/xrSupport.ts
var cached = null;
var immersiveARSupported = () => {
  if (cached) return cached;
  const xr = typeof navigator !== "undefined" ? navigator.xr : void 0;
  if (!xr) return Promise.resolve(false);
  const probe = xr.isSessionSupported("immersive-ar");
  cached = probe.catch(() => false);
  probe.catch(() => {
    cached = null;
  });
  return cached;
};
var warmUpImmersiveARSupport = () => {
  void immersiveARSupported().catch(() => void 0);
};
var resetImmersiveARSupportForTest = () => {
  cached = null;
};

export {
  captureArTestFlags,
  isArSyncActive,
  isArGyroActive,
  isArCoastActive,
  arBackendOverride,
  isArRecordActive,
  arLatencyOverrideMs,
  isArDebugActive,
  immersiveARSupported,
  warmUpImmersiveARSupport,
  resetImmersiveARSupportForTest
};
//# sourceMappingURL=chunk-PM3UV6CK.mjs.map